import { render, staticRenderFns } from "./KnowledgeBaseArticleView.vue?vue&type=template&id=73ab5720&scoped=true"
import script from "./KnowledgeBaseArticleView.vue?vue&type=script&lang=ts"
export * from "./KnowledgeBaseArticleView.vue?vue&type=script&lang=ts"
import style0 from "./KnowledgeBaseArticleView.vue?vue&type=style&index=0&id=73ab5720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ab5720",
  null
  
)

export default component.exports